import styled from 'styled-components'
import { MOBILE_WIDTH } from 'utils/constants'

export const ChangePasswordContainer = styled.form`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 2rem;
  background: #f8f8f8;
  width: 100%;
  height: 100%;
  min-height: 100vh;

  @media ${MOBILE_WIDTH} {
    padding: 1rem;
  }
`

export const WhiteCard = styled.div`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 2.5rem;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;

  @media ${MOBILE_WIDTH} {
    padding: 1.5rem;
    border-radius: 6px;
  }
`

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2.5rem;
`

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.5rem;

  .lock-icon {
    width: 1.75rem;
    height: 1.75rem;
    color: #333333;
    flex-shrink: 0;
    stroke-width: 1.5;
  }
`

export const MainTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #433f3e;
  font-family: 'Poppins', sans-serif;
  margin: 0;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;

  @media ${MOBILE_WIDTH} {
    font-size: 16px;
  }
`

export const Subtitle = styled.h2`
  font-size: 14px;
  font-weight: 400;
  color: #433f3e;
  font-family: 'Poppins', sans-serif;
  margin: 0;
  margin-bottom: 0.5rem;
  line-height: 140%;
  letter-spacing: 0%;
  height: 19.6px; /* 14px * 140% line-height */

  @media ${MOBILE_WIDTH} {
    font-size: 13px;
  }
`

export const SubtitleSpacer = styled.div`
  height: 19.6px;
  margin-bottom: 0.5rem;
`

export const ChangePasswordInputs = styled.div`
  display: flex;
  gap: 2rem;
  margin-bottom: 2.5rem;
  align-items: flex-start;

  @media ${MOBILE_WIDTH} {
    flex-direction: column;
    gap: 1.5rem;
  }
`

export const ChangePasswordInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  flex: 1;
  min-width: 0;
  width: 100%;
  max-width: 368.5px;

  /* Estilização customizada para os inputs de senha */
  > div {
    width: 100%;

    .input_wrapper {
      background: #edece7 !important;
      border: 1px solid #edece7 !important;
      border-radius: 4px !important;
      height: 36px !important;
      padding: 8px 16px !important;
      box-shadow: none !important;
      width: 100%;

      &:focus-within {
        border-color: #edece7 !important;
        box-shadow: none !important;
      }

      input {
        background: transparent !important;
        color: #333333 !important;
        font-size: 0.875rem !important;
        font-weight: 400 !important;
        font-family: 'Poppins', sans-serif !important;
        height: 100% !important;
        padding: 0 !important;

        &::placeholder {
          color: #999999 !important;
          font-weight: 400 !important;
          opacity: 1 !important;
        }
      }

      svg {
        color: #666666 !important;
        width: 1.25rem !important;
        height: 1.25rem !important;
      }
    }
  }
`

export const InputLabel = styled.label`
  font-size: 14px;
  font-weight: 400;
  color: #898483;
  font-family: 'Poppins', sans-serif;
  margin-bottom: 0.5rem;
  display: block;
  line-height: 140%;
  letter-spacing: 0%;
`

export const ForgotPasswordLink = styled.a`
  color: #6b7b3c;
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
  margin-top: 0;
  display: block;
  text-align: left;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  transition: opacity 0.2s;
  align-self: flex-start;

  &:hover {
    opacity: 0.8;
    text-decoration: none;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;

  @media ${MOBILE_WIDTH} {
    justify-content: stretch;
    margin-top: 1.5rem;

    button {
      width: 100%;
    }
  }
`
